import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App.vue'

import VueRouter from 'vue-router'
import router from './router'

import request from './utils/request.js'
Vue.prototype.$H = request;

import config from './utils/config.js'
Vue.prototype.$c = config;

import fun from './utils/function.js'
Vue.prototype.$f = fun;

// 挂载Vuex
import store from './store';
Vue.prototype.$store = store;

Vue.use(VueRouter)
Vue.use(ElementUI)

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})
